module.exports = "/assets/data/73bd909064547f5060fcfdfccc290ebe-NE63.data.json";